<script lang="ts">
  import { onDestroy, onMount } from 'svelte';
  import { fade, fly } from 'svelte/transition';

  import flags from '../../etc/flagKeys';
  import { AppState } from '../../etc/stores';
  import { isMobile } from '../../etc/utils';
  import { Auth } from '../../services/auth';
  import { Container } from '../../services/container';
  import Heading from '../typography/Heading.svelte';
  import Text from '../typography/Text.svelte';

  const auth = Container.get(Auth);

  const { primary500, typography } = $AppState.theme.colors;
  const isBlack = $AppState.theme.name === 'black';
  let width = 0;
  const isChangeAnimation = auth.provider === 'wix' && isMobile();
  const isWixResize =
    isChangeAnimation &&
    $AppState.featureFlags.includes(flags.MOBILE_WIX_RESIZE_WINDOW);

  let style = '';

  const onResize = event => {
    width = event.currentTarget.innerWidth;
    if (isMobile()) {
      style = `
        --twism-width-carousel: ${width - 64}px
      `;
    } else {
      style = '';
    }
  };

  onMount(() => {
    onResize({ currentTarget: { innerWidth: window.innerWidth } });
    window.addEventListener('resize', onResize, true);
  });

  onDestroy(() => {
    window.removeEventListener('resize', onResize, true);
  });

  const linearGradient = `linear-gradient(180deg, ${
    isBlack ? 'rgba(230, 241, 255, 0.16)' : primary500
  } 0%, ${
    isBlack ? 'rgba(255, 255, 255, 0)' : 'rgba(210, 237, 239, 0)'
  } 100%);`;
</script>

<div
  class="twism-carousel-animation"
  in:fade={{ delay: isChangeAnimation ? 1000 : 0, duration: 350 }}
>
  <div in:fly={{ delay: isChangeAnimation ? 1000 : 0, x: 30, duration: 350 }}>
    <div class="twism-carousel-card" {style}>
      <div class="twism-carousel-card__header">
        <div
          class="twism-carousel-card__icon-background"
          style={`background: ${linearGradient};`}
        >
          <slot name="icon" />
        </div>
        <Heading
          class="twism-carousel-card__title {!isWixResize
            ? 'twism-wix-title-resize'
            : ''}"
          type="h3"
          color={isBlack ? '#FFFFFFDB' : typography}
        >
          <slot name="title" />
        </Heading>
      </div>
      <Text
        class="twism-carousel-card__description {!isWixResize
          ? 'twism-wix-description-resize'
          : ''}"
        type={isMobile() ? 'default' : 'medium'}
        color={isBlack ? '#FFFFFFDB' : typography}
      >
        <slot name="description" />
      </Text>
    </div>
  </div>
</div>

<style lang="scss">
  :global(.twism-carousel-card__title) {
    font-weight: 500;
    @media screen and (max-width: 468px) and (min-height: 700px) {
      font-size: 18px !important;
      line-height: 22px !important;
    }
  }

  :global(.twism-wix-title-resize) {
    font-size: 16px !important;
  }

  :global(.twism-carousel-card__description) {
    opacity: 0.9 !important;
  }

  :global(.twism-wix-description-resize) {
    font-size: 14px !important;
  }

  .twism-carousel-animation {
    min-width: auto !important;
    max-width: 1000px !important;
  }

  .twism-carousel-card {
    padding: 24px;
    box-sizing: border-box;

    width: 296px;
    min-width: 296px !important;
    height: 171px;
    user-select: none;

    background: var(--twism-theme-welcome-backgroundCarousel);
    border-radius: 18px;
    box-shadow: 0px 8px 30px rgba(42, 70, 71, 0.09);
    margin: 0 8px;
    transform: translateX(15px);

    @media screen and (max-width: 468px) {
      width: var(--twism-width-carousel);
      min-width: var(--twism-width-carousel) !important;
      transform: translateX(15px);
      height: 200px !important;
    }

    @media screen and (max-width: 468px) and (min-height: 700px) {
      height: 220px !important;
    }

    &__header {
      display: flex;
      margin-bottom: 16px;
      align-items: center;
    }

    &__icon-background {
      height: 40px;
      width: 40px;
      min-width: 40px;
      border-radius: 20px;
      margin-right: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
</style>
